import { getCoordinatorApi } from "@/lib/api";

/** Grant an org-level role to an existing org member (`POST /orgs/{org}/members`). */
export const assignOrgMemberRole = async ({
  organizationId,
  accountId,
  role,
}: {
  organizationId: string;
  accountId: string;
  role: string;
}): Promise<void> => {
  const client = getCoordinatorApi({ organizationId });
  await client.post("/members", { account_id: accountId, role });
};
